import { Card } from "@/components/Card";
import { twMerge } from "tailwind-merge";

export function IconContainer({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <Card
      className={twMerge(
        "bg-theme-gradient-from/30 border-theme-gradient-from/40 flex w-fit items-center justify-center rounded-sm border p-1.5 backdrop-blur-lg",
        className,
      )}
    >
      {children}
    </Card>
  );
}
